import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Avatar } from '../components/ui/Avatar';
import { Badge } from '../components/ui/Badge';
import { Modal } from '../components/ui/Modal';
import { Toggle } from '../components/ui/Toggle';
import { useToast } from '../components/ui/Toast';
import { sellers as initialSellers } from '../utils/mockData';
import { QrCode, Smartphone, Bell, Shield, Target, LogOut, RefreshCw, CheckCheck } from 'lucide-react';
export function Configuracoes() {
  const {
    addToast
  } = useToast();
  const [sellers, setSellers] = useState(initialSellers);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [connectingSeller, setConnectingSeller] = useState<string | null>(null);
  const [connectionStep, setConnectionStep] = useState(0);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [autoMoveDeals, setAutoMoveDeals] = useState(false);
  const handleConnect = (sellerId: string) => {
    setConnectingSeller(sellerId);
    setConnectionStep(0);
    setIsQrModalOpen(true);
    setTimeout(() => setConnectionStep(1), 3000);
    setTimeout(() => {
      setConnectionStep(2);
      setSellers(prev => prev.map(s => s.id === sellerId ? {
        ...s,
        whatsappConnected: true
      } : s));
      addToast('WhatsApp conectado com sucesso!', 'success');
      setTimeout(() => setIsQrModalOpen(false), 1500);
    }, 5000);
  };
  const handleDisconnect = (sellerId: string) => {
    if (confirm('Tem certeza que deseja desconectar?')) {
      setSellers(prev => prev.map(s => s.id === sellerId ? {
        ...s,
        whatsappConnected: false
      } : s));
      addToast('WhatsApp desconectado', 'info');
    }
  };
  return <Layout data-id="element-370">
      <div className="space-y-8" data-id="element-371">
        <h1 className="text-3xl font-bold text-white" data-id="element-372">Configurações</h1>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-373">
          <div className="lg:col-span-1 space-y-2" data-id="element-374">
            {[{
            label: 'Conexões WhatsApp',
            icon: Smartphone,
            active: true
          }, {
            label: 'Metas e Objetivos',
            icon: Target
          }, {
            label: 'Notificações',
            icon: Bell
          }, {
            label: 'Usuários',
            icon: Shield
          }].map(item => <button key={item.label} className={`
                  w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-all
                  ${item.active ? 'bg-primary text-white shadow-lg shadow-primary/20' : 'text-text-secondary hover:bg-slate-800 hover:text-white'}
                `} data-id="element-375">
                <item.icon className="h-4 w-4 mr-3" data-id="element-376" />
                {item.label}
              </button>)}
          </div>

          <div className="lg:col-span-3 space-y-6" data-id="element-377">
            <Card className="p-6" data-id="element-378">
              <div className="flex justify-between items-center mb-6" data-id="element-379">
                <div data-id="element-380">
                  <h2 className="text-xl font-bold text-white" data-id="element-381">
                    Conexões WhatsApp
                  </h2>
                  <p className="text-text-muted text-sm" data-id="element-382">
                    Gerencie os números conectados de cada vendedor.
                  </p>
                </div>
                <Button variant="outline" icon={<QrCode className="h-4 w-4" data-id="element-384" />} data-id="element-383">
                  Nova Conexão
                </Button>
              </div>

              <div className="space-y-4" data-id="element-385">
                {sellers.map(seller => <div key={seller.id} className="flex items-center justify-between p-4 bg-slate-800/50 rounded-xl border border-slate-700/50" data-id="element-386">
                    <div className="flex items-center gap-4" data-id="element-387">
                      <Avatar src={seller.avatar} fallback={seller.name} data-id="element-388" />
                      <div data-id="element-389">
                        <p className="font-medium text-white" data-id="element-390">{seller.name}</p>
                        <p className="text-xs text-text-muted" data-id="element-391">
                          {seller.whatsappConnected ? '+55 11 99999-9999' : 'Não conectado'}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-4" data-id="element-392">
                      <Badge variant={seller.whatsappConnected ? 'success' : 'danger'} dot data-id="element-393">
                        {seller.whatsappConnected ? 'Conectado' : 'Desconectado'}
                      </Badge>
                      {seller.whatsappConnected ? <Button size="sm" variant="ghost" onClick={() => handleDisconnect(seller.id)} className="text-red-400 hover:text-red-300 hover:bg-red-500/10" data-id="element-394">
                          <LogOut className="h-4 w-4 mr-2" data-id="element-395" /> Desconectar
                        </Button> : <Button size="sm" variant="primary" onClick={() => handleConnect(seller.id)} data-id="element-396">
                          <QrCode className="h-4 w-4 mr-2" data-id="element-397" /> Conectar
                        </Button>}
                    </div>
                  </div>)}
              </div>
            </Card>

            <Card className="p-6" data-id="element-398">
              <div className="flex justify-between items-center mb-6" data-id="element-399">
                <div data-id="element-400">
                  <h2 className="text-xl font-bold text-white" data-id="element-401">Preferências</h2>
                  <p className="text-text-muted text-sm" data-id="element-402">
                    Personalize sua experiência.
                  </p>
                </div>
              </div>

              <div className="space-y-6" data-id="element-403">
                <Toggle checked={soundEnabled} onChange={setSoundEnabled} label="Sons de Notificação" description="Tocar som ao receber mensagens ou fechar vendas" data-id="element-404" />
                <Toggle checked={notificationsEnabled} onChange={setNotificationsEnabled} label="Notificações Desktop" description="Mostrar popups do navegador" data-id="element-405" />
                <Toggle checked={autoMoveDeals} onChange={setAutoMoveDeals} label="Mover Negócios Automaticamente" description="Avançar etapa baseado na conversa (IA)" data-id="element-406" />
              </div>
            </Card>

            <Card className="p-6" data-id="element-407">
              <div className="flex justify-between items-center mb-6" data-id="element-408">
                <div data-id="element-409">
                  <h2 className="text-xl font-bold text-white" data-id="element-410">
                    Metas Mensais
                  </h2>
                  <p className="text-text-muted text-sm" data-id="element-411">
                    Defina os objetivos de venda da equipe.
                  </p>
                </div>
                <Button variant="ghost" size="sm" data-id="element-412">
                  Salvar Alterações
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-413">
                <Input label="Meta da Equipe (R$)" defaultValue="1.000.000,00" data-id="element-414" />
                <Input label="Meta Individual Padrão (R$)" defaultValue="150.000,00" data-id="element-415" />
              </div>
            </Card>
          </div>
        </div>
      </div>

      <Modal isOpen={isQrModalOpen} onClose={() => setIsQrModalOpen(false)} title="Conectar WhatsApp" size="sm" data-id="element-416">
        <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-417">
          {connectionStep === 0 && <>
              <div className="bg-white p-4 rounded-xl mb-6" data-id="element-418">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=ExampleConnection" alt="QR Code" className="w-48 h-48" data-id="element-419" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-420">
                Escaneie o QR Code
              </h3>
              <p className="text-sm text-text-muted" data-id="element-421">
                Abra o WhatsApp no seu celular {'>'} Menu {'>'} Aparelhos
                conectados {'>'} Conectar aparelho
              </p>
            </>}

          {connectionStep === 1 && <>
              <div className="w-20 h-20 border-4 border-primary border-t-transparent rounded-full animate-spin mb-6" data-id="element-422" />
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-423">
                Conectando...
              </h3>
              <p className="text-sm text-text-muted" data-id="element-424">
                Aguarde enquanto estabelecemos a conexão.
              </p>
            </>}

          {connectionStep === 2 && <>
              <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center mb-6 animate-in zoom-in" data-id="element-425">
                <CheckCheck className="h-10 w-10 text-white" data-id="element-426" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-427">Conectado!</h3>
              <p className="text-sm text-text-muted" data-id="element-428">
                O número foi vinculado com sucesso.
              </p>
            </>}
        </div>
      </Modal>
    </Layout>;
}